var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Stack, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { Controller, useForm } from "react-hook-form";
export var SeasonForm = function (_a) {
    var season = _a.season, onSubmit = _a.onSubmit;
    var _b = useForm({
        defaultValues: {
            name: season === null || season === void 0 ? void 0 : season.name,
            startDate: season === null || season === void 0 ? void 0 : season.startDate,
            description: season === null || season === void 0 ? void 0 : season.description,
        },
    }), control = _b.control, handleSubmit = _b.handleSubmit, errors = _b.formState.errors;
    return (_jsx(Box, { component: "form", onSubmit: handleSubmit(onSubmit), noValidate: true, role: "form", sx: { mt: 1 }, children: _jsxs(Stack, { spacing: 2, children: [_jsx(Controller, { name: "name", control: control, rules: { required: "Season Name is required" }, render: function (_a) {
                        var field = _a.field;
                        return (_jsx(TextField, __assign({}, field, { label: "Season Name", required: true, margin: "normal", fullWidth: true, error: !!errors.name, helperText: errors.name ? errors.name.message : "" })));
                    } }), _jsx(Controller, { name: "startDate", control: control, rules: { required: "Start Date is required" }, render: function (_a) {
                        var _b, _c;
                        var field = _a.field;
                        return (_jsx(DatePicker, { label: "Start Date", value: field.value ? dayjs(field.value) : null, onChange: function (newValue) {
                                return field.onChange(newValue ? dayjs(newValue).format("YYYY-MM-DD") : undefined);
                            }, slotProps: {
                                textField: {
                                    margin: "normal",
                                    fullWidth: true,
                                    error: !!errors.startDate,
                                    helperText: ((_c = (_b = errors.startDate) === null || _b === void 0 ? void 0 : _b.message) === null || _c === void 0 ? void 0 : _c.toString()) || "",
                                },
                            } }));
                    } }), _jsx(Controller, { name: "description", control: control, render: function (_a) {
                        var _b, _c;
                        var field = _a.field;
                        return (_jsx(TextField, __assign({}, field, { label: "Description", multiline: true, minRows: 3, margin: "normal", fullWidth: true, error: !!errors.description, helperText: ((_c = (_b = errors.description) === null || _b === void 0 ? void 0 : _b.message) === null || _c === void 0 ? void 0 : _c.toString()) || "" })));
                    } }), _jsx(Button, { type: "submit", fullWidth: true, variant: "contained", sx: { mt: 3, mb: 2 }, children: season ? "Update" : "Create" })] }) }));
};
